import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  max-width: 360px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const HotelImage = styled.div`
  position: relative;

  height: 200px;

  img {
    object-fit: cover;
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

export const Location = styled.div`
  color: #555;
  font-size: 12px;
  margin-bottom: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Concept = styled.div`
  color: #999;
  font-size: 13px;
  min-height: 20px;
  margin-bottom: 8px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const FromText = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 4px;
`;

export const Button = styled.a`
  width: 100%;
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.primaryBrand};
  color: ${({ theme }) => theme.palette.white};
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  background: ${({ theme }) => theme.palette.primaryBrand};

  &:hover {
    color: ${({ theme }) => theme.palette.white};
    box-shadow: 0 10px 30px 0 ${({ theme }) => theme.palette.primaryBrandSoft};
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const PageTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 40px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 20px;
    font-size: 17px;
  }
`;

export const CarouselWrapper = styled.div`
  padding: 0px;

  .swiper-slide {
    max-width: 360px;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: auto;

  border-radius: 2px;
  color: ${({ theme }) => theme.palette.darkGrey};
  position: relative;
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 8px;
  }
`;
